import axios from "axios";
import Cookies from "js-cookie";
import { GeneratePublicToken } from "../utils/GeneratePublicToken";

const token = () => Cookies.get("accessToken");

export const listProduct = async (body) => {
  const TokenAuth = GeneratePublicToken().Authorization;
  const TokenAuthID = GeneratePublicToken()["Authorization-ID"];
  const isLogin = token() && token() !== undefined && token() !== null;

  const header = isLogin
    ? { Authorization: `Bearer ${token()}` }
    : { Authorization: TokenAuth, "Authorization-ID": TokenAuthID };

  try {
    const config = {
      headers: header,
      url: `${process.env.REACT_APP_API_PSEF}psef/products`,
      method: "POST",
      data: body,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};